import { render } from "./UiInviteDialog.vue?vue&type=template&id=42fc1d3e&scoped=true"
import script from "./UiInviteDialog.vue?vue&type=script&lang=js"
export * from "./UiInviteDialog.vue?vue&type=script&lang=js"

import "./UiInviteDialog.vue?vue&type=style&index=0&id=42fc1d3e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42fc1d3e"]])

export default __exports__